import colors from 'style-utils/colors';
import styled, { StyledProps } from 'styled-components';

type TypePropsNote = {
  containerPadding: string;
  containerMargin?: string;
  borderColor: string;
  borderSize: string;
  textColor: string;
  lineHeight: string;
  size: string;
};

type UlNoteProps = StyledProps<{
  paddingUlNote?: string;
}>;

export const Note = styled.div<TypePropsNote>`
  margin: 0;
  width: 100%;
  font-weight: 400;
  ${(props: TypePropsNote) =>
    `color: ${props.textColor};
    line-height: ${props.lineHeight};
    border-left: ${props.borderSize} solid ${props.borderColor};
    font-size: ${props.size};
    padding:${props.containerPadding};
    margin:${props.containerMargin ? props.containerMargin : ''};
    `};
  a {
    color: ${colors.blackTwelve};
    :visited {
      color: ${colors.blackTwelve};
    }
  }
`;

export const LinkPdf = styled.a`
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    color: #0000ff;
  }
`;

export const UlNote = styled.ul<UlNoteProps>`
  > li {
    list-style-type: disc;
  }

  a {
    color: ${colors.blackTwelve};
  }

  > span,
  span > span {
    > ul {
      padding: 0 0 0 16px;
      & > li,
      > span li {
        padding: ${({ paddingUlNote }) => `${paddingUlNote};`};
        list-style-type: disc;
      }
    }
  }
`;
